"use strict";

exports.__esModule = true;

var _reactUnicons = require("@iconscout/react-unicons");

exports.faSmile = _reactUnicons.UilSmile;
exports.faPencilAlt = _reactUnicons.UilEditAlt;
exports.faTrash = _reactUnicons.UilTrash;
exports.faAlignLeft = _reactUnicons.UilAlignLeft;
exports.faAlignCenter = _reactUnicons.UilAlignCenter;
exports.faAlignRight = _reactUnicons.UilAlignRight;
exports.faSquareFull = _reactUnicons.UilSquareFull;
exports.faListUl = _reactUnicons.UilListUl;
exports.faFont = _reactUnicons.UilFont;
exports.faFileImage = _reactUnicons.UilScenery;
exports.faHandPointer = _reactUnicons.UilSquare;
exports.faLink = _reactUnicons.UilLink;
exports.faPalette = _reactUnicons.UilPalette;
exports.faTextHeight = _reactUnicons.UilTextSize;